import { render } from "./Deposit.vue?vue&type=template&id=de3928ce&ts=true"
import script from "./Deposit.vue?vue&type=script&lang=ts"
export * from "./Deposit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__